/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goals_RememberInputs */

const en_onboarding_goals_remember = /** @type {(inputs: Onboarding_Goals_RememberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remember what I read`)
};

const es_onboarding_goals_remember = /** @type {(inputs: Onboarding_Goals_RememberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordar lo que leo`)
};

/**
* | output |
* | --- |
* | "Remember what I read" |
*
* @param {Onboarding_Goals_RememberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_goals_remember = /** @type {((inputs?: Onboarding_Goals_RememberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goals_RememberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_goals_remember(inputs)
	return en_onboarding_goals_remember(inputs)
});